import { render, staticRenderFns } from "./docVodaWithValue.vue?vue&type=template&id=e5805348"
import script from "./docVodaWithValue.vue?vue&type=script&lang=js"
export * from "./docVodaWithValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports